<template>
  <section class="space-y-3 p-4">
    <CarouselCard
      v-for="(route, idx) in routes"
      :key="idx"
      :offer="route"
      :offer-idx="idx"
      :cashback-click-source="
        analyticsEventsLib.config.SearchResultCardCashbackPriceClickSource
          .HOT_OFFERS
      "
      @click="emit('onCardClick', idx)"
      @onCashbackClick="bottomSheet.show(CASHBACK_BOTTOMSHEET)"
    />
    <Teleport to="body">
      <CashbackBottomSheet :name="CASHBACK_BOTTOMSHEET" />
    </Teleport>
  </section>
</template>

<script setup lang="ts">
  import { CashbackBottomSheet } from 'freedom-shared';
  import { controllerModel } from 'shared';

  import { CarouselCard } from '@/features/offers';

  import type { hotOffersTypes } from '@/entities/hot-offers';

  import { analyticsEventsLib } from '@/shared/lib';

  const CASHBACK_BOTTOMSHEET = 'cashback-bottom-sheet';

  const bottomSheet = controllerModel.useBottomSheet();

  defineProps<{
    routes: hotOffersTypes.MappedHotOffer[];
  }>();

  const emit = defineEmits<{
    onCardClick: [routeIdx: number];
    onCashbackClick: [];
  }>();
</script>
